/**
 * Browser storage that never throws: private windows, blocked site data and sandboxed previews
 * make `localStorage` / `sessionStorage` (or their accessors) throw. Every read and write is
 * wrapped; a failure behaves like "nothing stored".
 */
type Kind = 'local' | 'session';

function area(kind: Kind): Storage | null {
  try {
    return kind === 'local' ? globalThis.localStorage : globalThis.sessionStorage;
  } catch {
    return null;
  }
}

export function readStorage(kind: Kind, key: string): string | null {
  try {
    return area(kind)?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeStorage(kind: Kind, key: string, value: string | null): void {
  try {
    const s = area(kind);
    if (!s) return;
    if (value === null) s.removeItem(key);
    else s.setItem(key, value);
  } catch {
    // storage full / blocked: the value simply is not persisted
  }
}

export const STORAGE_KEYS = {
  /** Panel language ('mk' | 'en'), per browser. */
  locale: 'zinq.panel.locale',
  /** Signed-in session (access + refresh token), per tab. */
  session: 'zinq.panel.session',
  /** Research export key typed by the research team, per tab. */
  researchKey: 'zinq.research.key',
} as const;
